<template>
  <div>
    <div class="all-users-page">
      <h1 class="page-header color-1-100">Redirects</h1>
    </div>
    <div class="content-section">
      <div class="data-list-heading">
        <div class="data-list-statusbar">
          <div class="data-list-statusbar__contains data-list-statusbar__block">
            {{ redirects.length + (redirects.length === 1 ? ' redirect' : ' redirects') }}
          </div>
        </div>
        <a href="#"
           v-on:click.prevent="displayAddForm()"
           class="data-list-add"
           :class="[{ 'data-list-add__close': addFormDisplay}]"
           tabindex="-1">Add new redirect</a>
      </div>
      <div class="categories-add-form" v-if="addFormDisplay">
        <div class="form-group">
          <div class="form-element">
            <label for="input-redirect-from" class="form-label color-2-63">From</label>
            <input type="text"
                   id="input-redirect-from"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newRedirect.fromUrl"/>
          </div>
        </div>
        <div class="form-group">
          <div class="form-element">
            <label for="input-redirect-to" class="form-label color-2-63">To</label>
            <input type="text"
                   id="input-redirect-to"
                   class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                   v-model="newRedirect.toUrl"/>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="update-data update-data__details">
          <a href="#" v-on:click.prevent="closeAddForm()" class="cancel-edit background-2-7 color-2-100 cancel-edit-details">Cancel</a>
          <a href="#" v-on:click.prevent="createRedirect()" class="save-edit background-1-100 color-2-100 save-edit-details">Create redirect</a>
        </div>
        <hr class="add-form-delimiter" />
      </div>
      <div class="data-list-body">
        <table class="table table-data">
          <thead class="categories-list-body__head">
          <tr>
            <th class="cellpadding categories-list-body__head_id table-head-ceil">ID</th>
            <th class="categories-list-search-col text-left categories-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchFrom"
                          type="search"
                          class="table-search"
                          placeholder="From ..."/>
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th class="categories-list-search-col text-left categories-list-body__head_search table-head-ceil">
              <div class="table-search-wrap">
                <div class="wrap-input">
                  <input
                          v-model="searchTo"
                          type="search"
                          class="table-search"
                          placeholder="To ..."/>
                </div>
                <div class="wrap-search-icon"></div>
              </div>
            </th>
            <th colspan="2" class="cellpadding categories-list-body__head_actions table-head-ceil">Actions</th>
          </tr>
          </thead>
          <tbody class="categories-list-body__body">
          <tr v-for="(redirect, i) in updatedRedirects">
            <td class="text-center cellpadding" v-if="redirect.type === 'show'" style="width: 50px;">
              {{redirect.id}}
            </td>
            <td class="cellpadding" v-if="redirect.type === 'show'">
              {{ redirect.fromUrl }}
            </td>
            <td class="cellpadding" v-if="redirect.type === 'show'">
              {{ redirect.toUrl }}
            </td>
            <td class="cellpadding text-center" v-if="redirect.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m edit-btn"
                      @click="switchEditMode(redirect.id)">
                <span class="table-tooltip">Edit</span>
              </button>
            </td>
            <td class="cellpadding text-center" v-if="redirect.type === 'show'" style="width: 50px;">
              <button
                      type="button"
                      class="table-crud-btn icon-btn-m delete-btn"
                      @click="removeRedirect(redirect.id)">
                <span class="table-tooltip">Delete</span>
              </button>
            </td>
            <td colspan="6" v-if="redirect.type === 'edit'" class="edit-row chapter-edit">
              <div class="wrap-edit-form">
                <div class="row-edit-form">
                  <div>
                    <label for="edit-from" class="form-label color-2-63">Redirect from</label>
                    <input type="text"
                           id="edit-from"
                           placeholder="Type in redirect from"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="redirect.fromUrl">
                  </div>
                  <div>
                    <label for="edit-to" class="form-label color-2-63">Redirect to</label>
                    <input type="text"
                           id="edit-to"
                           placeholder="Type in redirect to"
                           class="form-control form-control__input background-1-10-disabled  border-1-10-disabled"
                           v-model="redirect.toUrl">
                  </div>
                </div>
                <div class="wrap-table-control-panel">
                  <button type="button" @click="discardChanges(redirect.id)">Cancel</button>
                  <button type="button" @click="editRedirect(redirect.id)">Save</button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'redirects',
  data () {
    return {
      infMsgTitle: '',
      infMsgDescription: '',
      infMsgClass: '',
      redirects: [],
      updatedRedirects: [],
      newRedirect: {
        fromUrl: '',
        toUrl: ''
      },
      disableAPI: false,
      searchFrom: '',
      searchTo: '',
      filerTableHead: {
        selectedCeil: null
      },
      addFormDisplay: false
    }
  },
  methods: {
    ...mapActions([
      'setInformationMsg',
      'clearConfAction',
      'initConfAction'
    ]),
    displayAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    closeAddForm () {
      this.addFormDisplay = !this.addFormDisplay
    },
    removeRedirect (id) {
      this.initConfAction({
        actionId: id,
        actionName: 'removeRedirectById'
      })
    },
    removeRedirectConfirmed (id) {
      let self = this
      let thisRedirect = this.updatedRedirects.find((redirect) => redirect.id === id)
      this.$http.delete(api.URLS.redirect + '/' + id, api.headersAuthSettings)
          .then((res) => {
            self.infMsgTitle = `Redirect from "${thisRedirect.fromUrl}" to "${thisRedirect.toUrl}" was successfully deleted.`
            self.infMsgDescription = 'Please note all actions are being logged.'
            self.infMsgClass = 'success'
            self.setInformationMsg({
              isShown: true,
              title: self.infMsgTitle,
              text: self.infMsgDescription,
              className: self.infMsgClass
            })
            for (let i = 0; i < self.redirects.length; i++) {
              if (self.redirects[i].id === id) {
                self.redirects.splice(i, 1)
                break
              }
            }
          })
          .catch((err) => console.log(err))
    },
    fetchAllContentByScroll () {
      this.$http.get(`${api.URLS.redirect}/list`, api.headersAuthSettings)
        .then((res) => {
          this.redirects = []
          if (res.body) {
            for (let i = 0; i < res.body.length; i++) {
              this.redirects.push({
                id: res.body[i].id,
                fromUrl: res.body[i].from_url,
                toUrl: res.body[i].to_url
              })
            }
            console.log(this.redirects)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    createRedirect () {
      if (this.disableAPI) return
      if (!this.newRedirect.fromUrl) return
      if (!this.newRedirect.toUrl) return
      let formData = {
        fromUrl: this.newRedirect.fromUrl,
        toUrl: this.newRedirect.toUrl
      }
      this.disableAPI = true
      this.$http.post(api.URLS.redirect, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.infMsgTitle = `Redirect from "${res.body.from_url}" to "${res.body.to_url}" was successfully created.`
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
          this.newRedirect.fromUrl = ''
          this.newRedirect.toUrl = ''
          this.addFormDisplay = false
          this.fetchAllContentByScroll()
        })
        .catch((err) => {
          this.disableAPI = false
          this.infMsgTitle = 'Error. We can\'t create this redirect because '
          for (let error in err.body.error.exception) {
            this.infMsgTitle += err.body.error.exception[error].message + ' '
          }
          if (this.getUserRole === 'gm') {
            this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
          } else {
            this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
          }
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        })
    },
    switchEditMode (id) {
      for (let redirect of this.updatedRedirects) {
        if (redirect.type === 'edit') redirect.type = null
        if (redirect.id === id && redirect.type === null) {
          redirect.type = 'edit'
        }
      }
    },
    editRedirect (id) {
      if (this.disableAPI) return
      let redirect = this.updatedRedirects.find((redirect) => redirect.id === id && redirect.type === 'edit')
      let formData = {
        id: id,
        fromUrl: redirect.fromUrl,
        toUrl: redirect.toUrl
      }
      this.disableAPI = true
      this.$http.post(api.URLS.redirect, formData, api.headersAuthSettings)
        .then((res) => {
          this.disableAPI = false
          this.discardChanges(id)
          this.fetchAllContentByScroll()
          this.infMsgTitle = `Redirect from "${res.body.from_url}" to "${res.body.to_url}" was successfully updated.`
          this.infMsgDescription = 'Please note all actions are being logged.'
          this.infMsgClass = 'success'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        })
        .catch((err) => {
          this.disableAPI = false
          this.infMsgTitle = 'Error. We can\'t create this redirect because '
          for (let error in err.body.error.exception) {
            this.infMsgTitle += err.body.error.exception[error].message + ' '
          }
          if (this.getUserRole === 'gm') {
            this.infMsgDescription = 'If you need assistance, please send an email to tcc@eromagency.com in the following format: “I was on this page (insert the URL of the page where you got this error), did this action, was expecting to get this result, but got this error instead. It happened at this time on this date, while using this operating system and this browser (please insert browser version as well - usually it can be found in browser menu → Help → About), being logged in with this user. On a scale from 1 to 10 (where 1 means there is no rush and 10 means I need it yesterday), I need a solution for this with this priority”. Thank you.'
          } else {
            this.infMsgDescription = 'If you believe there is something wrong with our system, please drop us an email to support.team@clearassured.co.uk with more information about what went wrong and we will look into it. Thank you.'
          }
          this.infMsgClass = 'error'
          this.setInformationMsg({
            isShown: true,
            title: this.infMsgTitle,
            text: this.infMsgDescription,
            className: this.infMsgClass
          })
        })
    },
    discardChanges (id) {
      for (let redirect of this.updatedRedirects) {
        if (redirect.id === id && redirect.type === 'edit') {
          redirect.type = null
        }
      }
    },
    hideSubMenuTableHead (e) {
      this.filerTableHead.selectedCeil = null
    }
  },
  computed: {
    ...mapGetters([
      'getConfData'
    ]),
    filteredRedirects () {
      console.log(this.redirects)
      return this.redirects.filter((redirect) => redirect.fromUrl.toLowerCase().indexOf(this.searchFrom.toLowerCase()) > -1 &&
        redirect.toUrl.toLowerCase().indexOf(this.searchTo.toLowerCase()) > -1)
    }
  },
  watch: {
    filteredRedirects: function () {
      let updatedRedirects = []
      this.filteredRedirects.forEach((redirect, i, arr) => {
        redirect.type = 'show'
        updatedRedirects.push(redirect)
        updatedRedirects.push({
          type: null,
          id: redirect.id,
          fromUrl: redirect.fromUrl,
          toUrl: redirect.toUrl
        })
      })
      this.updatedRedirects = updatedRedirects
    },
    'getConfData.actionConfirmed' (value) {
      if (value) {
        this.removeRedirectConfirmed(this.getConfData.actionId)
        this.clearConfAction()
      }
    }
  },
  components: {},
  mounted () {
    this.fetchAllContentByScroll()
    document.addEventListener('click', this.hideSubMenuTableHead)
  },
  created () {
    document.title = 'Dashboard redirects | Clear Assured'
    if (window.ga) {
      window.ga('set', 'contentGroup1', 'ADMINISTRATION_AREA')
      window.ga('send', 'pageview', {
        'page': location.pathname,
        'location': location.href,
        'title': document.title
      })
    }
  },
  destroyed () {
    document.addEventListener('click', this.hideSubMenuTableHead)
  }
}
</script>

<style src='@/assets/scss/components/table.scss' lang='scss' scoped />



// WEBPACK FOOTER //
// Redirects.vue?37b74580